import VTableCard from '@/vuetify_custom/v-table-card'
import VRippleCol from '@/vuetify_custom/v-ripple-col';
import { VSpacer } from 'vuetify/lib'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        tableCardFields() {
            return [
                 {
                   label: '申请开店主体',
                   type: 'company_field',
                   key: 'company_id'
                 },
                 {
                     key: 'materials'
                 }
            ]
        }
    },
    render() {
        const _this = this
        return <VTableCard 
                    sub-title="法务信息"
                    value={_this.target}
                    fields={_this.tableCardFields}
                    cols={12}
                    scopedSlots={{
                        materials({ value}) {
                            const materials = value.materials
                            if (!materials || !materials.length) {
                                return ''
                            }
                            return <div style={{width: '100%'}}>
                                  <VRippleCol cols={12}> <span style="white-space:nowrap"></span><VSpacer/><span></span></VRippleCol>
                                    <VRippleCol cols={12}>
                                        <span style="white-space:nowrap">所需资质证书：</span>
                                        <VSpacer/>
                                   </VRippleCol>   
                            { 
                            materials.map(child => {
                                return <VRippleCol cols={12}>
                                    <span style="white-space:nowrap">{child.material_name}</span>
                                    <VSpacer/>
                                   <p 
                                    style={{
                                        margin:'0 0 0 20px'
                                    }}
                                   >
                                        {child && child.labels && child.labels.map((label, index) => <p>{`${label}:${child.values && child.values[index] || '-'}`}</p>)}
                                    </p> 
                                </VRippleCol>
                              
                            })}
                            </div> 
                           
                            
                        }
                    }}
                />
    }
}